<mat-form-field [appearance]="appearance() || 'outline'" subscriptSizing="dynamic" [ngStyle]="formFieldStyles()">
    <mat-label>Type d'objet maquette</mat-label>
    <mat-select data-tfa="type-objet-maquette_select" [formControl]="control()">
        <mat-option data-tfa="option-vide" [value]="null">-</mat-option>
        <mat-option [attr.data-tfa]="'option-' + TypeObjetMaquette.Formation" [value]="TypeObjetMaquette.Formation">Formation</mat-option>
        <mat-option [attr.data-tfa]="'option-' + TypeObjetMaquette.ObjetFormation" [value]="TypeObjetMaquette.ObjetFormation"
            >Objet de formation</mat-option
        >
        <mat-option [attr.data-tfa]="'option-' + TypeObjetMaquette.Groupement" [value]="TypeObjetMaquette.Groupement"
            >Groupement</mat-option
        >
    </mat-select>
</mat-form-field>
